import { saveAs } from 'file-saver';
import {
  EDataLookupType,
  EPropertyLookupMode,
  IAPNLookupColumnMapping,
  IDataLookup,
  IDataLookupFile,
  IPropertyLookupColumnMapping,
} from 'types/data-lookup';

import { apiClient } from '.';

export const submitAPNLookup = async (
  file: File,
  columnMapping: IAPNLookupColumnMapping,
  onUploadProgress?: (progress: number) => void,
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('lookupType', EDataLookupType.APNLookup);
  formData.append('columnMapping', JSON.stringify(columnMapping));

  const response = await apiClient.post('/data-lookups', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (event) => {
      if (onUploadProgress && event.total) {
        onUploadProgress(Math.round((event.loaded / event.total) * 100));
      }
    },
  });
  return response.data.data as IDataLookup;
};

export const submitPropertyLookup = async (
  file: File,
  lookupMode: EPropertyLookupMode,
  columnMapping: IPropertyLookupColumnMapping,
  paymentMethodId: string,
  onUploadProgress?: (progress: number) => void,
) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('lookupType', EDataLookupType.PropertyLookup);
  formData.append('lookupMode', lookupMode);
  formData.append('columnMapping', JSON.stringify(columnMapping));
  formData.append('paymentMethodId', paymentMethodId);

  const response = await apiClient.post('/data-lookups', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (event) => {
      if (onUploadProgress && event.total) {
        onUploadProgress(Math.round((event.loaded / event.total) * 100));
      }
    },
  });
  return response.data.data as IDataLookup;
};

export const downloadDataLookupFile = async (
  dataLookupId: string,
  file: IDataLookupFile,
) => {
  const response = await apiClient.get(`/data-lookups/${dataLookupId}/files/${file._id}`, {
    responseType: 'blob',
  });
  saveAs(response.data, file.filename);
};
